/* @flow */

import React from 'react';

type Props = {
  filled: boolean,
};

const Heart = ({ filled = false }: Props) =>
  <svg viewBox="0 0 24 24">
    <path
      fill={filled ? 'currentColor' : 'none'}
      fillRule="evenodd"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 21.6l9.2-9.3c2.4-2.3 2.4-6.2 0-8.5-2.3-2.4-6-2.4-8.5 0l-.7.7-.7-.7C9 1.4 5 1.4 2.8 3.8.4 6 .4 10 2.8 12.3l9.2 9.3z"
    />
  </svg>;

export default Heart;



// WEBPACK FOOTER //
// ../src/client/components/icons/Heart.js